/* eslint-disable import/prefer-default-export */
const THIRTY_SECONDS = 30000;

/**
 * 
 * @param {function():Promise} exec 
 * @param {number} timeout 
 * @param {boolean} backoffOnError 
 */
async function promiseRetry(exec, {
  maxRetries = Number.MAX_SAFE_INTEGER,
  initialTimeout = THIRTY_SECONDS,
  attempt = 0
} = {}) {
  try {
    const res = await exec();
    return res;
  } catch (err) {
    if (attempt < maxRetries) {
      return wait(initialTimeout, attempt).then(() => {
        return promiseRetry(exec, {
          initialTimeout,
          attempt: attempt + 1,
          maxRetries
        });
      });
    }
    throw err;
  }
}
function wait(timeout, attempt) {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, 2 ** attempt * timeout);
  });
}
export { promiseRetry };